import React, { Component } from "react";
import loginbanner from "views/stepPortal/image/login/loginbanner.png";
class Right extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div>
        <img src={loginbanner} alt="loginbanner" className="h-screen w-full" />
      </div>
    );
  }
}
export default Right;
